<template>
  <div
    class="tw-font-sans tw-antialiased tw-w-full tw-fixed tw-bg-white tw-z-10"
    id="app"
  >
    <nav
      class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-py-2 tw-px-8"
    >
      <div
        class="tw-flex tw-items-center tw-flex-no-shrink tw-text-white tw-mr-6"
      >
        <router-link to="/">
          <div
            class="tw-flex tw-items-center tw-flex-no-shrink tw-text-black tw-mr-6"
          >
            <img
              class="inline m-1"
              src="https://res.cloudinary.com/dldd8ucby/image/upload/v1580808183/Eko%20Carbon/logo_2.png"
            />
          </div>
        </router-link>
      </div>
      <div class="tw-block lg:tw-hidden">
        <button
          @click="toggle"
          class="tw-flex tw-items-center tw-px-3 tw-py-2 tw-border tw-rounded tw-text-teal-lighter tw-border-teal-light"
        >
          <svg
            class="tw-fill-current tw-h-3 tw-w-3"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        :class="open ? 'tw-block' : 'tw-hidden'"
        class="tw-w-full tw-flex-grow lg:tw-flex sm:tw-items-center lg:tw-w-auto"
      >
        <div class="tw-text-sm lg:tw-flex-grow"></div>
        <div>
          <router-link
            to="/"
            class="tw-block tw-mt-4 lg:tw-inline-block md:tw-px-4 about tw-uppercase  lg:tw-mt-0 tw-mr-4"
            >Who we are</router-link
          >
          <router-link
            to="/home/projects"
            class="tw-block tw-mt-4 lg:tw-inline-block md:tw-px-4 about tw-uppercase  lg:tw-mt-0 tw-mr-4"
            >Projects</router-link
          >
          <button
            @click="dialog = true"
            id=""
            class="tw-block tw-mt-4 lg:tw-inline-block md:tw-px-4 about tw-uppercase  lg:tw-mt-0 tw-mr-4"
          >
            Carbon Calculator
          </button>
          <router-link
            to="/auth/login"
            id=""
            class="tw-block tw-mt-4 lg:tw-inline-block tw-px-2 tw-bg-white tw-text-center tw-border tw-border-blue-500 tw-rounded tw-text-lg md:tw-px-4 tw-rounded lg:tw-mt-0 tw-mr-4 md:tw-py-1 signin"
            >Sign In</router-link
          >
          <router-link
            to="/auth/register"
            id=""
            class="tw-block tw-mt-4 lg:tw-inline-block tw-px-2 tw-text-white tw-text-center tw-bg-blue-500 tw-rounded tw-w-auto tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 register"
            >Sign Up</router-link
          >
        </div>
      </div>
    </nav>

    <!-- Calculator Modal -->
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Carbon Emmission Calculator
          </v-card-title>
          <Calculator />
        </v-card>
      </v-dialog>
    </div>

    <vue-element-loading
      v-if="loading"
      :active="loading"
      :is-full-screen="true"
    />
  </div>
</template>

<script>
import Calculator from "../Shared/HeaderCalculator.vue";
export default {
  components: {
    Calculator,
  },
  data() {
    return {
      open: false,
      dialog: false,
      errors: {},
      data: {},
      start: {},
      end: {},
      trip: "",
      loading: false,
      carbon: "",
      price: 0,
      difference: "",
    };
  },
  methods: {
    toggle() {
      console.log(this.open);
      this.open = !this.open;
    },
  },
};
</script>

<style scoped>
div {
  font-family: "Muli";
}
.my-header {
  color: white;
  background-color: #141720;
  z-index: 100;
}
.register {
  color: #fff;
  width: fit-content;
}
.signin,
.about {
  color: #000;
  width: fit-content;
}
</style>
